import * as React from 'react';
import classnames from 'classnames';
import { Hr } from '@grandvisionhq/elements';

const ConfigurationSummaryDivider = ({ isSmallScreen , className  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames('configuration-summary-divider', className)
    }, isSmallScreen ? /*#__PURE__*/ React.createElement(Line, null) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Line, null), /*#__PURE__*/ React.createElement(Line, null), /*#__PURE__*/ React.createElement(Line, null)))
;
const Line = ()=>/*#__PURE__*/ React.createElement(Hr, {
        className: "configuration-summary-divider__line"
    })
;
var ConfigurationSummaryDivider$1 = ConfigurationSummaryDivider;

export { ConfigurationSummaryDivider$1 as default };
//# sourceMappingURL=ConfigurationSummaryDivider.js.map
